import React, { useState } from "react";
import Section from "../../Section";
import { innerRenderPaths } from "../../../assest/imgPaths";
import image1 from "../../../assest/Nikea/images/image3.jpeg";
import image2 from "../../../assest/Nikea/images/image5.jpeg";
import bestLocation from "../../../assest/Nikea/images/image6.jpeg";

import List from "./List";

const ProjectWhySection = () => {
  const [activeImg, setActiveImg] = useState(1);

  const onHoverHandler = (number) => {
    setActiveImg(number);
  };
  return (
    <Section bg="bg-primary-bg-blue/90">
      <div
        data-v-08671491=""
        id="w-node-_0fb033b0-5a5d-3ec8-4959-b379dd738f4a-0a6b3cff"
        className="col-span-10 col-start-2  grid grid-cols-9 gap-5 py-16 text-primary-bg-blue max-h-[694px] "
      >
        {/* სურათი */}
        <div
          data-v-08671491=""
          className="hidden xl:block h-full max-h-[594px] col-start-1 col-span-4 overflow-hidden "
        >
          {activeImg === 1 && (
            <img
              data-v-08671491=""
              src={bestLocation}
              loading="lazy"
              data-nuxt-img=""
              className="h-full w-full object-cover transition-all animate-fadeIn"
              alt="K2 Invest Group"
            />
          )}
          {activeImg === 2 && (
            <img
              data-v-08671491=""
              src={image1}
              loading="lazy"
              data-nuxt-img=""
              className="h-full w-full object-cover transition-all animate-fadeIn"
              alt="K2 Invest Group"
            />
          )}
          {activeImg === 3 && (
            <img
              data-v-08671491=""
              src={image2}
              loading="lazy"
              data-nuxt-img=""
              className="h-auto w-full object-cover transition-all animate-fadeIn"
              alt="K2 Invest Group"
            />
          )}
          {activeImg === 4 && (
            <img
              data-v-08671491=""
              src={innerRenderPaths[11]}
              loading="lazy"
              data-nuxt-img=""
              className="h-auto w-full object-cover transition-all animate-fadeIn"
              alt="K2 Invest Group"
            />
          )}
          {/* <img
              data-v-08671491=""
              src={imgSrc}
              loading="lazy"
              data-nuxt-img=""
              className="h-full w-auto object-cover transition-all animate-fadeIn"
              alt="K2 Invest Group"
            /> */}
        </div>
        {/* ჩამონათვალი */}
        <div
          data-v-08671491=""
          className="max-h-fit xl:col-start-5 col-span-7 xl:col-span-6 tracking-wider font-bold text-2xl xl:text-4xl xl:px-16 text-primary-light"
        >
          <h2 className="font-gilroy">რატომ K2 ნიკეაზე?</h2>
          <div className="w-full h-[2px] bg-primary-bg-blue/70 my-8" />
          <List activeImg={activeImg} onHoverHandler={onHoverHandler} />
        </div>
      </div>
    </Section>
  );
};

export default ProjectWhySection;
